<template>
  <v-container fluid class="ma-0 pa-0 fill-height">
    <v-row style="height: 100%" justify="center" align="center">
      <v-col cols="12">
        <v-row justify="center" align="center">
          <v-col cols="10" md="4">
            <v-card tile outlined raised>
              <v-container fluid>
                <v-row align="center">
                  <v-col
                    cols="12"
                    align-self="center"
                    style="text-align:center"
                  >
                    <v-img
                      src="/img/WR_positiva.png"
                      contain
                      height="80px"
                      class="mb-5"
                      v-on:click="gotoMain()"
                      style="cursor:pointer"
                    ></v-img>
                    <span>Redefinir senha </span>
                    <br />
                    <span>Utilize seu e-mail e redefina sua senha</span>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    class="mt-3"
                    align-self="center"
                    style="text-align:center"
                  >
                    <v-form ref="resetForm" v-model="valid" lazy-validation>
                      <v-text-field
                        v-model="loginData.email"
                        name="email"
                        :rules="rules.email"
                        outlined
                        rounded
                        label="E-mail"
                        required
                      ></v-text-field>
                      <v-text-field
                        v-model="loginData.password"
                        name="new_password"
                        type="password"
                        outlined
                        rounded
                        :rules="rules.pass"
                        label="Senha"
                        required
                      ></v-text-field>
                      <v-text-field
                        v-model="loginData.confirm"
                        name="password_confirmation"
                        type="password"
                        outlined
                        rounded
                        :rules="rules.pass"
                        label="Confirme sua senha"
                        required
                      ></v-text-field>

                      <v-btn
                        :disabled="!valid"
                        :loading="loading"
                        v-on:click="redefinePassword()"
                        color="success"
                        block
                      >
                        Alterar Senha
                      </v-btn>
                    </v-form>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-snackbar
      v-model="snackbar"
      bottom
      right
      :color="responseStatus"
      :timeout="3000"
    >
      {{ responseMSG }}
    </v-snackbar>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "Login",
  components: {},
  data: () => ({
    snackbar: false,
    loading: false,
    valid: true,
    loginData: {
      token: "",
      email: "",
      password: "",
      confirm: ""
    },
    forgotPass: false,
    rules: {
      email: [
        (v) => !!v || "Campo obrigatório",
        (v) => /.+@.+\..+/.test(v) || "E-mail precisa ser válido"
      ],
      pass: [(v) => !!v || "Campo obrigatório"]
    }
  }),
  computed: {
    ...mapState({
      responseStatus: (state) => state.authStore.responseStatus,
      responseMSG: (state) => state.authStore.responseMsg,
      isLoggedIn: (state) => state.appStore.isLoggedIn,
      routePath: (state) => state.route.path
    })
  },
  methods: {
    redefinePassword: async function() {
      this.loading = true;
      if (this.$refs.resetForm.validate()) {
        await this.$store.dispatch("authStore/setNewPassword", this.loginData);
        this.snackbar = true;
        this.loading = false;
      }
    },
    gotoMain: function() {
      this.$router.push("/");
    }
  },
  mounted() {
    const query = this.$router.history.current.query;
    let token, email;
    try {
      token = query.token;
      email = query.email;
    } catch (ReferenceError) {
      token = "";
      email = "";
    } finally {
      this.loginData.email = email;
      this.loginData.token = token;
    }
    if (typeof token == "undefined") {
      this.$router.push("/login");
    }
    if (this.isLoggedIn) {
      this.$router.push("/");
    }
  }
};
</script>
